import getDomains from '@/utils/getDomains'
import { HttpClient } from './httpClient'
import useLanguage from '@/hooks/useLanguage'

export const appVersion = '1.0.1'

const http = new HttpClient()
http.requestInterceptor({
  onFulfilled: config => {
    const defaultHeaders = {
      'Web-Id': localStorage.getItem('web_id') || '',
      'App-Version': appVersion,
      'Tz': Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      'accept-language': useLanguage().locale,
      'Entry-Type': getDomains().thirdLevelDomain === 'edu' ? 'edu' : 'main',
      ...config.headers
    }
    if (!config.headers) {
      config.headers = {} as Record<string, string>
    }
    Object.assign(config.headers, defaultHeaders)
    //请求拦截
    return config
  }
})

// http.responseInterceptor({
//   onFulfilled: (response) => {
//     //响应拦截
//     return response;
//   },
//   onRejected: (error) => {
//     //响应拦截
//     return error;
//   },
// });

export default http
